import React, { useEffect, useState } from 'react';
import { constants } from '../../../misc/constants';
import { getWindowVariable, reactToSmeDebug } from '../../../misc/tools';
import { BaseConfig } from '../../BaseConfig';
import { UIProperties } from '../../UIProperties';
import { SideMenuUIConfig } from './SideMenu';
var interval: any = null;
var currTime = -1000;

var forceStop=false;

(window as any)['stopApneaBar'] = () => {
	forceStop = true;
}
var animateAnimation = false;

const ApneaBar = (props: UIProperties<ApneaBarConfig>) => {
	const [percentage, setPercentage] = useState(0);
	const [isIdle, setIsIdle] = useState(undefined);
	const [forceUpdate, setForceUpdate] = useState(false);
	useEffect(() => {
		(window as any).apneaBarRefresh = (sideMenuParams: SideMenuUIConfig) => {
			var changed = false;
			if(typeof(sideMenuParams.isApneaTimerIdle) !== 'undefined') {
				props.parameters.isIdle = sideMenuParams.isApneaTimerIdle;
				setIsIdle(sideMenuParams.isApneaTimerIdle);
				changed = true;
			}

			if(typeof(sideMenuParams.apneaTimeInSeconds) !== 'undefined') {
				animateAnimation = sideMenuParams.resetEtc02;
				if(animateAnimation) {
					// var percentage = 1 - (props.parameters.apneaTimeInSeconds / sideMenuParams.apneaTimeInSeconds);
					// var maxIncrease = percentage * sideMenuParams.apneaTimeInSeconds;
					// var totalCalls = 220 * 5;
					// var step = maxIncrease / totalCalls; 
					var step = 0.1; 

					var currentVal = currTime;
					var int = setInterval(() => {
						currentVal -= step;
						currTime = currentVal;
						currTime = Math.round(currTime);

						if(currTime <= 0) {
							clearInterval(int);
							currTime = 0;
							animateAnimation = false;
						}
						setPercentage((currentVal / sideMenuParams.apneaTimeInSeconds) * 100);
					}, 0)
				} else {
					props.parameters.timeInSeconds = sideMenuParams.apneaTimeInSeconds;
					changed = true;
				}
			}

			if(typeof(sideMenuParams.inductionTimeInSeconds) !== 'undefined') {
				props.parameters.startOffsetInSeconds = sideMenuParams.inductionTimeInSeconds;
				changed = true;
			}

			if(changed) {
				setForceUpdate(!forceUpdate);
			}
		}
		if(!interval) {
			reactToSmeDebug('ApneaBar', () => {
				var testInductionTime = getWindowVariable(constants.smeDebug.variables.apneaInductionTime);
				var testapneaTime = getWindowVariable(constants.smeDebug.variables.apneaApneaTime);
				
				props.parameters.startOffsetInSeconds = testInductionTime;
				props.parameters.timeInSeconds = testapneaTime;
				currTime = -1000;
				setPercentage(0);
			});
			var step = 1000;
			
			interval = setInterval(() => {
				if(props.parameters.isIdle || forceStop || animateAnimation) {
					return;
				}
				if(currTime === -1000) {
					currTime = -props.parameters.startOffsetInSeconds;
				}
				currTime += (step / 1000);

				if(currTime > props.parameters.timeInSeconds) {
					clearInterval(interval);
					interval = null;
					return;
				}

				if(currTime > 0) {
					setPercentage((currTime / props.parameters.timeInSeconds) * 100);
				}
			}, step);
		}
		
		return () => {
			// if(interval) {
			// 	clearInterval(interval);
			// 	interval = null;
			// }
		}
	}, [percentage]);
	return (
		<div className="modal-disable-select" style={{
			position: 'absolute',
			right: '35px',
			top: '26px',
			width: '159px',
			height: '272px'
		}}>
			<div style={{
				backgroundColor: 'red',
				position: 'absolute',
				top: '0',
				left: percentage + '%',
				width: '7px',
				height: '272px'
			}}></div>
		</div>
	);

};

export interface ApneaBarConfig extends BaseConfig{
	isIdle: boolean;
	startOffsetInSeconds: number;
	timeInSeconds: number;
}

export default ApneaBar;